//* --------------------------------------------------*\
//    $SELECTORS - CSS selectors ONLY
// -  tag names, #ids, .classnames, [attributes], etc
//* --------------------------------------------------*/

const SELECTORS = {
  ACCORDION: '.accordion',
  ACCORDION_BUTTON: '.accordion__button',
  ACCORDION_PANEL: '.accordion__panel',
  ALL: '#all',
  ANCHOR: 'a',
  ANCHOR_WITH_HREF: 'a[href]',
  API_RESULTS: '[data-loadcomponent="APIResults"]',
  BACKGROUND: '.background',
  BUTTON: 'button',
  BODY: 'body',
  CHECKED: ':checked',
  CHECKED_LABEL: ':checked + label',
  CHECKBOX: 'checkbox',
  CLEAR_FILTERS: '.clear-filters',
  CLOSE: '.close',
  CLOSE_SEARCH: '.close-search',
  DATA_SHOW: 'data-show',
  CLOSE_FILTERS: '.close-filters',
  DATA_BOTTOM: 'data-bottomposition',
  DATA_HALFWAY: 'data-halfway',
  DATA_HAS_ANIMATED: 'data-has-animated',
  DATA_LAZY_LOAD: 'data-lazyload',
  DATA_MOUSEFOLLOW: '[data-mousefollow]',
  DATA_POSITION: 'data-position',
  DATA_VISIBLE: '[data-visible]',
  DIV: 'div',
  DROPDOWN: '.dropdown',
  DROPDOWN_BUTTON: '.dropdown__button',
  EMAIL: '.share--email',
  EYE: '.eye',
  FACEBOOK: '.share--facebook',
  FILE_INPUT: 'input[type=file]',
  FACETWP_SEARCH: '.facetwp-search',
  FILTER: '.filter',
  FILTER_CHOICE: '.filter-choice',
  FILTER_FORM: '.filters-form',
  FILTER_OPTION: '.filter-option',
  FILTER_TRIGGER: '.filter-trigger',
  FOCUSABLE_NODES:
    'a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
  FORM: 'form',
  FORM_CONTROL: '.form__control',
  FORM_FIELDS: 'input, select, textarea',
  FUN_FACT_ITEM: '.fun-fact__item',
  HEADER_CONTROL: '.header__control',
  HEADER_CONTROL_BUTTON: '.header__control-icon',
  HEADER_NAV: '.header__nav',
  HEADER_MENU_FIRST: '.header__menu--links-title',
  HTML: 'html',
  INVALID: ':invalid',
  LINK: '.share--link',
  LINKEDIN: '.share--linkedin',
  LISTING_APPLIED_FILTERS: '.listing__appliedfilters',
  LISTING_FILTERS: '.listing__filters',
  LIST_ITEMS_NO_RESULTS: '.listitems__noresults',
  LOADING: '.loading',
  LOAD_MORE: '.load-more',
  MAP_BOTTOM: '.map__bottom',
  MAP_PROFILE: '.mapprofile',
  MAP_PROFILE_BUTTON: '.mapprofile__button',
  MAP_SELECT: '.mapselect__select',
  MAP_SVG: '.map__svg',
  MAP_SVG_G: '.map__svg g',
  MAP_TOP: '.map__top',
  MENU_TXT: '.menu-txt',
  MOUSEFOLLOW: '.mousefollow',
  NAV_TRIGGER: '.nav_trigger',
  NESTED: '.nested',
  NEXT_FACT: '.next-fact',
  OGDESC: 'meta[property="og:description"]',
  OGTITLE: 'meta[property="og:title"]',
  OGURL: 'meta[property="og:url"]',
  OPEN_SEARCH: '.open-search',
  OPTGROUP: 'optgroup',
  PAGINATION: '.pagination',
  PARAGRAPH: 'p',
  POST_COUNT: '.post-count .count',
  POST_LISTING: '.post-listing',
  RADIO: '[type="radio"]',
  RESULTS_CONTAINER: '.results-container',
  SEARCH_FORM: '#searchform',
  SEARCH_INPUT: '.searchform__input',
  SEARCH_SUBMIT: '.searchform__submit',
  SELECTED: '.selected',
  SHOW_FILTERS: '.show-filters',
  SHOW_RESULTS: '.show-results',
  SPAN: 'span',
  STATE: '.state',
  STATISTIC_VALUE: '.statistic__value',
  SUBMISSION_RESPONSE: '.submission-response',
  SUBMIT: '[type="submit"]',
  TAB: '[role="tab"]',
  TABPANEL: '[role="tabpanel"]',
  TWITTER: '.share--twitter',
  URLSHARE: '.share--url',
  VIDEO_TRIGGER: '.video__container',
  VIDEO_EMBED: '.video__embed',
  ZOOM_IN: '.zoomin',
  ZOOM_OUT: '.zoomout'
};

export default SELECTORS;
